<template>
  <div id="top" class="default-box closure-screen">
    <div class="home">
      <div class="star-background behind"></div>
      <div class="star-background moving"></div>

      <div class="main hero-scene">
        <img src="/assets/images/jupiter.svg" class="jupiter" alt="Jowisz" />
        <img src="/assets/images/logo.svg" class="logo" alt="Logo Kids Play Jupiter" />
        <img src="/assets/images/astronaut.svg" class="astronaut" alt="Astronauta" />

        <div class="closure-message">
          <p>Z przyczyn niezależnych od nas</p>
          <h1>Kids Play Jupiter zostało zamknięte na stałe</h1>
          <p>Dziękujemy Wam za wspólnie spędzony czas!</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BaseLayout'
}
</script>

<style scoped>
.closure-screen {
  min-height: 100vh;
}

.home {
  position: relative;
  min-height: 100vh;
  overflow: hidden;
}

.hero-scene {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
}

.closure-message {
  position: relative;
  z-index: 15;
  width: min(900px, 92vw);
  padding: clamp(1.25rem, 3vw, 2rem);
  border: 2px solid rgba(255, 255, 255, 0.88);
  border-radius: 16px;
  background: rgba(17, 0, 25, 0.74);
  box-shadow: 0 18px 60px rgba(0, 0, 0, 0.45);
  backdrop-filter: blur(2px);
  text-align: center;
  color: #fff;
}

.closure-message h1 {
  margin: 0;
  font-size: clamp(1.5rem, 3.8vw, 2.8rem);
  line-height: 1.2;
  text-shadow: 2px 2px 12px rgba(0, 0, 0, 0.55);
}

.closure-message p {
  margin: 0.9rem 0 0;
  font-size: clamp(1.05rem, 2.4vw, 1.5rem);
  line-height: 1.4;
}

@media (max-width: 767px) {
  .closure-message {
    width: 90vw;
  }
}
</style>